import { PhotoCapture } from '../enums';
export const PHOTO_CAPTURE_GET_AUTHENTICATION_DATA_REQUEST = `${PhotoCapture.PHOTO_CAPTURE}_GET_AUTHENTICATION_DATA_REQUEST`;
export const PHOTO_CAPTURE_GET_AUTHENTICATION_DATA_SUCCESS = `${PhotoCapture.PHOTO_CAPTURE}_GET_AUTHENTICATION_DATA_SUCCESS`;
export const PHOTO_CAPTURE_GET_DATA_FAILURE = `${PhotoCapture.PHOTO_CAPTURE}_GET_DATA_FAILURE`;
export const PHOTO_CAPTURE_UPDATE_TNC = `${PhotoCapture.PHOTO_CAPTURE}_UPDATE_TNC`;
export const photoCaptureGetAuthenticationDataAction = (coCode, contextId, brandedNotificationInputs) => ({
    type: PHOTO_CAPTURE_GET_AUTHENTICATION_DATA_REQUEST,
    payload: { coCode, contextId, brandedNotificationInputs }
});
export const photoCaptureGetAuthenticationDataSuccessAction = photoCaptureAuthenticationData => ({
    type: PHOTO_CAPTURE_GET_AUTHENTICATION_DATA_SUCCESS,
    payload: { photoCaptureAuthenticationData }
});
export const photoCaptureDataFailureAction = failureMessage => ({
    type: PHOTO_CAPTURE_GET_DATA_FAILURE,
    payload: { failureMessage }
});
export const photoCaptureUpdateTncAction = (isTermsAndConditionsAccepted) => ({
    type: PHOTO_CAPTURE_UPDATE_TNC,
    payload: isTermsAndConditionsAccepted
});
//# sourceMappingURL=photoCaptureGetAuthenticationAction.js.map